import React from 'react';
import * as _ from 'lodash';
import './CarLayout.css';
import {connect} from 'react-redux';
import {setPartID} from '../../../../stores/CarDamage/CarReducer';
import {loadWageList} from '../../../../stores/CarDamage/WageReducer';
import {loadPartList} from '../../../../stores/CarDamage/PartReducer';

class CarLayout extends React.Component {

  partPositions = [
    {
      'label': '1',
      'style': {'left': '50px', 'top': '0px'},
    },
    {
      'label': '2',
      'style': {'left': '180px', 'top': '0px'},
    },
    {
      'label': '3',
      'style': {'left': '20px', 'top': ' 90px'},
    },
    {
      'label': '4',
      'style': {'left': '210px', 'top': '90px'},
    },
    {
      'label': '5',
      'style': {'left': '20px', 'top': ' 190px'},
    },
    {
      'label': '6',
      'style': {'left': '210px', 'top': '190px'},
    },
    {
      'label': '7',
      'style': {'left': '20px', 'top': ' 270px'},
    },
    {
      'label': '8',
      'style': {'left': '210px', 'top': '270px'},
    },
    {
      'label': '9',
      'style': {'left': '20px', 'top': ' 360px'},
    },
    {
      'label': '10',
      'style': {'left': '210px', 'top': '360px'},
    },
    {
      'label': '11',
      'style': {'left': '60px', 'top': ' 460px'},
    },
    {
      'label': '12',
      'style': {'left': '180px', 'top': '460px'},
    },
    {
      'label': '13',
      'style': {'left': '115px', 'top': '220px'},
    },
  ];

  constructor(props) {
    super(props);
  }

  carPosition(index) {
    return this.partPositions[index].style;
  }

  carImageURL(car_type) {
    const car_types = {
      'sedan': 'https://demo2.bigfix.co/korat/img/normalcar2.png',
      'van': 'https://demo2.bigfix.co/korat/img/van5.png',
      'pickup': 'https://demo2.bigfix.co/korat/img/pickup2.png',
    };

    try {
      return car_types[this.props.car.carType.toLowerCase()]
             || this.props.carUrl
             || car_types['sedan'];
    } catch (ex) {
      return this.props.carUrl || car_types['sedan'];
    }

  }

  selectSpot = (part_id) => (e) => {
    const {dispatch, car} = this.props;
    const newCar = {
      ...car,
      partID: part_id,
    };
    dispatch(loadWageList(newCar));
    dispatch(loadPartList(newCar));

    dispatch(setPartID({
      partID: part_id,
    }));
  };

  render() {
    const {state, props} = this;
    return (
        <div id={'car-damage-layout'}>
          <div id="container">
            <img id="car_body_canvas"
                 src={this.carImageURL(props.car.carType)} />
            {
              this.partPositions.map((item, index) => {
                    return (
                        <div key={index}
                             className={[
                               'damage-spot-circle',
                               props.car.partID == item.label ? 'active' : '',
                             ].join(' ')}
                             onClick={this.selectSpot(item.label)}
                             style={item.style}>{item.label}</div>
                    );
                  },
              )
            }
          </div>
        </div>
    );
  }
}

export default connect(
    (state, props) => ({...state, ...props}),
)(CarLayout);


// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/CarLayout/CarLayout.js